/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {ModeloFormComponent} from "./modelo-form/modelo-form.component";
import {editRoute, newRoute} from "../../shared/services/data.service";

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class ModelosRoutingModule {}

export const modelosRoutes: any[] = [
  {
    path: editRoute + '/:id',
    component: ModeloFormComponent
  },{
    path: newRoute,
    component: ModeloFormComponent
  }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/modelos/modelos-routing.module.ts
 **/